var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { DexfSettingsUtility, LocalizedInformationAlternateLanguage } from '@inter-ikea-kompis/utilities';
import { HyperlinkColorEnum } from '@inter-ikea-kompis/component-hyperlink';
import { Hyperlink } from '@inter-ikea-kompis/component-hyperlink';
import { Text } from '@inter-ikea-kompis/component-text';
import { globe, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import LanguageSelectorLinkGroupStyle from './LanguageSelectorLinkGroupStyle.js';
/**
 * LanguageSelectorLinkGroup class.
 *
 * @event change A change event is triggered when a new language is selected.
 */
export default class LanguageSelectorLinkGroup extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "settings" instead.
        this.localizedInformation = null;
        // The settings retrieved from settings service.
        this.settings = null;
        this.selected = false;
        this.dexfSettings = null;
    }
    render() {
        // We want settings to be required, but since both props to provide settings are optional, this check is needed until localizedInformation is removed.
        if (!this.hasSettings()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				${LanguageSelectorLinkGroupStyle.getStyle({
            theme: this.theme,
            selected: this.selected
        })}
			</style>
			<div class="container">${this.getIcon()} ${this.getLinks()}</div>
		`;
    }
    async connectedCallback() {
        registerIcon(globe);
        this.customElements.define('skapa-icon', SkapaIcon);
        this.customElements.define('kompis-text', Text);
        this.customElements.define('kompis-hyperlink', Hyperlink);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has('localizedInformation') &&
            this.localizedInformation &&
            !this.settings) {
            this.dexfSettings = DexfSettingsUtility.parseLocalizedInformation(this.localizedInformation);
        }
        if (changedProperties.has('settings') && this.settings) {
            this.dexfSettings = this.settings;
        }
        return true;
    }
    hasSettings() {
        return !!this.dexfSettings || !!this.localizedInformation;
    }
    getSettings() {
        return this.dexfSettings;
    }
    /**
     * Returns icon.
     *
     * @returns Template.
     */
    getIcon() {
        return html ` <skapa-icon icon="globe"></skapa-icon> `;
    }
    /**
     * Gets links.
     *
     * @returns Template.
     */
    getLinks() {
        return LocalizedInformationAlternateLanguage.getAlternateLanguages(this.getSettings(), this.locale).map((language) => html ` <kompis-text .theme="${this.theme}">
						<kompis-hyperlink
							class="link"
							role="checkbox"
							aria-checked="${this.locale === language.locale}"
							data-text="${language.label}"
							.theme="${this.theme}"
							.text="${language.label}"
							.color="${HyperlinkColorEnum.black}"
							@linkClick="${() => this.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { locale: language.locale } }))}"
						></kompis-hyperlink>
					</kompis-text>
					<div class="divider" tabindex="-1"></div>`);
    }
}
__decorate([
    property({ type: Object })
], LanguageSelectorLinkGroup.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], LanguageSelectorLinkGroup.prototype, "settings", void 0);
__decorate([
    property({ type: Object, required: true })
], LanguageSelectorLinkGroup.prototype, "theme", void 0);
__decorate([
    property({ type: String, required: true })
], LanguageSelectorLinkGroup.prototype, "locale", void 0);
//# sourceMappingURL=LanguageSelectorLinkGroup.js.map